<template>
<Veranstaltungen v-if="componentUp == 'Veranstaltungen'"/>
<Apothekenfinder v-if="componentUp == 'Apothekenfinder'"/>
</template>

<script setup>
import { useDataStore } from "@/store/";
import Veranstaltungen from '@/components/Veranstaltungen';
import Apothekenfinder from '@/components/Apothekenfinder';
const componentUp = (typeof component === 'undefined') ? "Apothekenfinder" : component;

const dataStore = useDataStore();
dataStore.setPluginType(componentUp);
</script>
